import { render, staticRenderFns } from "./ModalHelpScreen.vue?vue&type=template&id=324a04e7&scoped=true&"
import script from "./ModalHelpScreen.vue?vue&type=script&lang=js&"
export * from "./ModalHelpScreen.vue?vue&type=script&lang=js&"
import style0 from "./ModalHelpScreen.vue?vue&type=style&index=0&id=324a04e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324a04e7",
  null
  
)

export default component.exports